import { Info, StatusCellRenderer } from "./GridFrameworks";

export const columnDef = [
    {
        field: "Id",
        headerName: "",
        width: 60,
        cellRenderer: Info,
    },
    {
        field: "LaborServiceName",
        headerName: "Service name",
        flex: 1,
        minWidth: 200,
        sortable: true,
        filter: true,
    },
    {
        field: "Unit",
        headerName: "Unit",
        width: 100,
        sortable: true,
        filter: true,
    },
    {
        field: "UnitPrice",
        headerName: "Price ($)",
        width: 120,
        sortable: true,
        filter: true,
        valueFormatter: (params: any) => {
            if (params.value === undefined || params.value === null) return "";
            return `$${Number(params.value).toFixed(2)}`;
        },
    },
    {
        field: "IsActive",
        headerName: "Status",
        width: 120,
        cellRenderer: StatusCellRenderer,
    }
];
